import { render, staticRenderFns } from "./AppRouterLinkComponent.vue?vue&type=template&id=170cd587&scoped=true&"
import script from "./AppRouterLinkComponent.ts?vue&type=script&lang=ts&"
export * from "./AppRouterLinkComponent.ts?vue&type=script&lang=ts&"
import style0 from "./AppRouterLinkComponent.scss?vue&type=style&index=0&id=170cd587&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170cd587",
  null
  
)

export default component.exports